import { eachDayOfInterval, startOfMonth, endOfMonth, format } from 'date-fns';

const monthNames = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];

const getMonthDays = (year, month) => {
  const monthDate = new Date(year, month - 1, 1);
  return eachDayOfInterval({
    start: startOfMonth(monthDate),
    end: endOfMonth(monthDate)
  }).map(date => format(date, 'yyyy-MM-dd'));
};

/**
 * Calculate daily totals from excursions array
 */
export const calculateDailyTotals = (excursions, year, month) => {
  const allDays = getMonthDays(year, month);
  const counts = {};

  excursions.forEach(exc => {
    const dateKey = format(new Date(exc.timestamp), 'yyyy-MM-dd');
    counts[dateKey] = (counts[dateKey] || 0) + 1;
  });

  return allDays.map(date => ({ date, count: counts[date] || 0 }));
};

export const generateYearOptions = (yearsBack = 5) => {
  const currentYear = new Date().getFullYear();
  const options = [];

  for (let i = 0; i <= yearsBack; i += 1) {
    const year = currentYear - i;
    options.push({ value: year, label: String(year) });
  }

  return options;
};

export const generateMonthOptions = () =>
  monthNames.map((name, index) => ({
    value: index + 1,
    label: name
  }));

export const getMonthLabel = (year, month) => `${monthNames[month - 1]} ${year}`;

export const getExcursionTypeLabel = type => {
  const types = {
    temperature: 'Temperature',
    humidity: 'Humidity',
    battery: 'Battery'
  };
  return types[type] || type || 'Unknown';
};

export const formatLimits = (type, limits) => {
  if (!limits) return '-';

  switch (type) {
    case 'temperature':
      if (limits.tMin != null && limits.tMax != null) {
        return `${limits.tMin}°C - ${limits.tMax}°C`;
      }
      if (limits.tMin != null) return `Min: ${limits.tMin}°C`;
      if (limits.tMax != null) return `Max: ${limits.tMax}°C`;
      return '-';
    case 'humidity':
      if (limits.hMin != null && limits.hMax != null) {
        return `${limits.hMin}% - ${limits.hMax}%`;
      }
      if (limits.hMin != null) return `Min: ${limits.hMin}%`;
      if (limits.hMax != null) return `Max: ${limits.hMax}%`;
      return '-';
    case 'battery':
      if (limits.bMin != null) return `Min: ${limits.bMin}V`;
      return '-';
    default:
      return '-';
  }
};

export const formatValue = (type, value, min, max) => {
  if (value == null) return '-';

  let unit = '';
  let deviation = '';

  switch (type) {
    case 'temperature':
      unit = '°C';
      if (min != null && value < min) {
        deviation = ` (${(value - min).toFixed(1)} < ${min})`;
      } else if (max != null && value > max) {
        deviation = ` (+${(value - max).toFixed(1)} > ${max})`;
      }
      break;
    case 'humidity':
      unit = '%';
      if (min != null && value < min) {
        deviation = ` (${(value - min).toFixed(0)} < ${min})`;
      } else if (max != null && value > max) {
        deviation = ` (+${(value - max).toFixed(0)} > ${max})`;
      }
      break;
    case 'battery':
      unit = 'V';
      break;
    default:
      break;
  }

  return `${value}${unit}${deviation}`;
};
